import type { SxProps, Theme } from '@mui/material/styles';

export const mergeSx = (
  ...parts: Array<SxProps<Theme> | undefined | false | null>
): SxProps<Theme> => {
  const filtered = parts.filter(
    (part): part is SxProps<Theme> => part != null && part !== false,
  );
  if (filtered.length === 0) return {};
  if (filtered.length === 1) return filtered[0];
  return filtered.flatMap((part) => (Array.isArray(part) ? part : [part]));
};
